var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"px-2 mb-0",attrs:{"title":_vm.$t('Visualizar e Imprimir'),"to":_vm.to,"target":"_blank","size":"xs","type":"button","variant":"primary"}},[_c('i',{staticClass:"mdi mdi-eye"})])
}
var staticRenderFns = []

export { render, staticRenderFns }